<template>
  <div
    class="exibition"
    :class="{ active: exibition}"
  >
  </div>
</template>

<script>
export default {
  props: {
    exibition: {
      type: Boolean
    }
  }
}
</script>

<style lang="scss" scoped>
  .exibition {
    display: inline;

     &:before {
      content: '';
      display: inline-block;
      width: 10px;
      height: 10px;
      -moz-border-radius: 7.5px;
      -webkit-border-radius: 7.5px;
      border-radius: 7.5px;
      margin-left: 7px;
      margin-top: 7px;
      background-color: $gray-100;
    }
  }

  .active {
    &:before {
      background-color: $success;
    }
  }

  @media only screen and (max-width: 768px) {
    .exibition {
      &:before {
        width: 7px;
        height: 7px;
        margin-left: 5px;
        margin-top: 5px;
      }
    }
  }
</style>
